export const ACTION_CLICK = 'click';
export const ACTION_VIEW = 'view';
